module.exports = __webpack_public_path__ + "img/logo.33ba8d86.jpg";